import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import Swap from "pages/swap";
import HomePage from "pages/home";
import Layout from "components/layout";
import Disclaimer from "pages/disclaimer";
import SwapContext from "context/swap-context";
import { isSwapRouteEnabled } from "utils/helper";

const RouteComponent = () => {
  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            <Layout>
              <HomePage />
            </Layout>
          }
        />
        {isSwapRouteEnabled && (
          <Route
            path="/swap"
            element={
              <Layout>
                <SwapContext>
                  <Swap />
                </SwapContext>
              </Layout>
            }
          />
        )}
        <Route
          path="/disclaimer"
          element={
            <Layout>
              <Disclaimer />
            </Layout>
          }
        />
        <Route path="*" element={<Navigate to={"/"} />} />
      </Routes>
    </>
  );
};

export default RouteComponent;
